import {BlockComponentProps} from 'client-react-block-renderer';
import React, {Component} from 'react';
import getSuggestedProducts from './getSuggestedProducts';
import SuggestedProductsView from './SuggestedProductsView';

interface Props extends BlockComponentProps<Data, Config> { }
interface Config {
    headerText: string;
    productCount: string; // is really a number in a string
    fallBackTagName: string;
}

interface Data {
    products: any[];
}

interface State {
    loading: boolean;
    products: any[];
}

export default class SuggestedProductsBlock extends Component<Props, State> {
    constructor(props) {
        super(props);
        this.state = {products: [], loading: true};
    }

    public componentDidMount() {
        this.ensureHaveCorrectNumberOfProducts();
    }

    /**
     * Here we fill in any missing spaces with products from the fallBackTagName.
     * Products can be missing because the admin did not select enough or
     * because some selected products are currently unavailable.
     *
     * Note that this.props.data.products is the initial product list and this.state.products is
     * the corrected products list
     */
    public ensureHaveCorrectNumberOfProducts() {
        const config = this.props.config;
        // @todo: Update RCM block editor to provide data for newly-added blocks
        const data =
            (this.props.data && Object.keys(this.props.data).length > 0) ?
                this.props.data as Data :
                { products: [] };
        const countShortfall = parseInt(config.productCount) - data.products.length;

        if (countShortfall > 0
            // Allow blank to mean "disable fall back product filling".
            && config.fallBackTagName
        ) {
            getSuggestedProducts(
                config.fallBackTagName,
                countShortfall,
                data.products.map((product) => product.id)
            ).then((fillerProducts) => {
                const products = data.products.concat(fillerProducts);
                this.setState({products, loading: false});
            });
        } else {
            this.setState({products: data.products, loading: false});
        }
    }

    public render() {
        return (<div>
            {!this.state.loading &&
            <SuggestedProductsView products={this.state.products}
                                   headerText={this.props.config.headerText}
                                   productCountOverride={parseInt(this.props.config.productCount)}/>
            }
        </div>);
    }
}
